<template>
  <div class="WorkDetail">
    <div class="flex">
      <img
        @click="$emit('close')"
        class="close"
        src="@/assets/img/close.png"
        alt=""
      />
    </div>
    <div class="main">
      <div class="head flex">
        <span class="head_title">生成介绍PDF</span>
        <!-- <div class="flex change_btn" id="sortType" @click="checkShowPDFList">
          <img src="@/assets/img/change_model.png" alt="" />
          更换模板
          <PDFList
            v-show="showPDFList"
            id="sortPanel"
            @click.stop
            @checkTemplate="checkTemplate"
            @close="showPDFList = false"
          />
        </div> -->
        <div class="download_btn" @click="generatePDF">
          {{ downloading ? "正在生成中" : "生成并下载" }}
        </div>
      </div>
      <div class="main_content flex" ref="main_content">
        <new-user-guide
          :visible="showGuide"
          @onNext="onNext"
          :content="guideContent"
          :guide-index="guideIndex"
          :last-index="lastIndex"
          :arrow-position="arrowPosition"
          :top="top"
          :left="left"
        ></new-user-guide>
        <div class="content_left column">
          <span class="content_left_title">画板</span>
          <div
            class="board_item"
            :class="{ active_board_item: index == activeBoardIndex }"
            v-for="(item, index) in pdfPage"
            :key="index"
            @click="activeBoardIndex = index"
          >
            <div class="thumbnail_item">
              <img v-if="item.thumbnail" :src="item.thumbnail" alt="" />
            </div>
            <div class="num">{{ index }}</div>
            <div
              class="copy flex"
              v-if="item.canCopy"
              @click="copyPage(item, index)"
            >
              <img src="@/assets/img/copy.png" alt="" />
            </div>
          </div>
        </div>
        <div class="content_middle flex">
          <component
            :is="currentComponent"
            :pdfPage="pdfPage"
            :activePDFPage="activePDFPage"
            :style="{ transform: `scale(${this.scaleRadio / 100})` }"
            ref="pdfPageRef"
          ></component>
          <div class="scale_panel flex">
            <img @click="reduce" src="@/assets/img/reduce.png" alt="" />
            <img @click="plus" src="@/assets/img/plus_2.png" alt="" />
            <span>{{ scaleRadio }}%</span>
          </div>
        </div>
        <div class="content_right">
          <!-- 公司主体信息 -->
          <div v-if="'mainInfo' == activePDFPage.type" class="column">
            <div class="flex">
              <span class="title">封面</span>
              <div
                class="delele_page"
                @click="deletePage"
                v-if="activePDFPage.canCopy"
              >
                删除此页
              </div>
            </div>
            <div class="column">
              <span class="subtitle">品牌</span>
              <input
                type="text"
                class="input"
                v-model="pdfPage[activeBoardIndex].data.brand"
                maxlength="4"
              />
            </div>
            <div class="column">
              <span class="subtitle">企业名称</span>
              <input
                type="text"
                class="input"
                v-model="pdfPage[activeBoardIndex].data.companyName"
              />
            </div>
            <div class="column">
              <span class="subtitle">愿景</span>
              <input
                type="text"
                class="input"
                v-model="pdfPage[activeBoardIndex].data.vision"
              />
            </div>
            <div class="column">
              <span class="subtitle">使命</span>
              <input
                type="text"
                class="input"
                v-model="pdfPage[activeBoardIndex].data.mission"
              />
            </div>
            <div class="column">
              <span class="subtitle">简介</span>
              <input
                type="text"
                class="input"
                v-model="pdfPage[activeBoardIndex].data.companyContent"
              />
            </div>
            <div class="column">
              <span class="subtitle">历史</span>
              <el-row
                v-for="(item, index) in pdfPage[activeBoardIndex].data.history"
                :key="index"
                :gutter="4"
                style="margin-bottom: 6px;"
              >
                <el-col :span="12">
                  <el-date-picker
                    v-model="item.historyTime"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    clear-icon=""
                  >
                  </el-date-picker>
                </el-col>
                <el-col :span="12"
                  ><input
                    type="text"
                    class="input historyInput"
                    v-model="item.history" /></el-col
              ></el-row>
            </div>
          </div>
          <!-- 服务与产品 -->
          <div v-if="'productList' == activePDFPage.type" class="column">
            <div class="flex">
              <el-tooltip
                class="item"
                effect="dark"
                content="这里的数据是从资料设置的产品与项目中来"
                placement="top"
              >
                <span class="title">服务与产品</span>
              </el-tooltip>
              <!-- <div class="checkbox_con flex">
                <input type="checkbox" /><span>在PDF中展示此页</span>
              </div> -->
              <div class="delele_page" @click="deletePage">删除此页</div>
            </div>
            <div class="warmTips">
              <i class="iconfont icon-jinggao"></i
              >&nbsp;&nbsp;每个服务与产品只可以绑定一个ppt页面
            </div>
            <div
              class="gray_con"
              v-for="(item, index) in productList"
              :key="index + 'productList'"
            >
              <div
                class="mask"
                v-if="item.belong && item.belong != activePDFPage.id"
              ></div>
              <div class="flex">
                <span class="title2">{{ item.projectName }}</span>
                <div class="checkbox_con flex">
                  <input
                    type="checkbox"
                    v-model="item.isShow"
                    @change="changeShow(item)"
                  /><span>展示</span>
                </div>
              </div>
              <div class="column">
                <span class="subtitle">描述</span>
                <textarea
                  v-model="item.projectIntro"
                  class="input textarea"
                ></textarea>
              </div>
              <div class="column">
                <span class="subtitle">特色</span>
                <textarea
                  v-model="item.projectFeature"
                  class="input textarea"
                ></textarea>
              </div>
              <div class="column">
                <span class="subtitle">相关图片</span>
                <div class="img_con">
                  <div
                    class="upload_area column"
                    @click="seletctImg(item.fileList)"
                  >
                    <img src="@/assets/img/plus.png" alt="" />
                    <span>上传</span>
                  </div>
                  <div
                    class="img_item"
                    v-for="(file, index) in item.fileList"
                    :key="index + 'productListimg'"
                  >
                    <img :src="file.fileUrl" alt="" />
                    <div class="mask flex">
                      <img
                        @click="toShowImg(file.fileUrl)"
                        src="@/assets/img/look.png"
                        alt=""
                      />
                      <img
                        @click="item.fileList.splice(index, 1)"
                        src="@/assets/img/delete_3.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 项目和案例 -->
          <div v-if="'projectList' == activePDFPage.type" class="column">
            <div class="flex">
              <el-tooltip
                class="item"
                effect="dark"
                content="这里的数据是从资料设置的产品与项目中来"
                placement="top"
              >
                <span class="title">项目和案例</span>
              </el-tooltip>
              <!-- <div class="checkbox_con flex">
                <input type="checkbox" /><span>在PDF中展示此页</span>
              </div> -->
              <div class="delele_page" @click="deletePage">删除此页</div>
            </div>
            <div class="warmTips">
              <i class="iconfont icon-jinggao"></i
              >&nbsp;&nbsp;每个项目只可以绑定一个ppt页面
            </div>
            <div
              class="gray_con"
              v-for="(item, index) in projectList"
              :key="index + 'projectList'"
            >
              <div
                class="mask"
                v-if="item.belong && item.belong != activePDFPage.id"
              ></div>

              <div class="flex">
                <span class="title2">{{ item.projectName }}</span>
                <div class="checkbox_con flex">
                  <input
                    type="checkbox"
                    v-model="item.isShow"
                    @change="changeShow(item, 'projectList')"
                  /><span>展示</span>
                </div>
              </div>
              <div class="column">
                <span class="subtitle">描述</span>
                <textarea
                  v-model="item.projectIntro"
                  class="input textarea"
                ></textarea>
              </div>
              <div class="column">
                <span class="subtitle">客户反馈</span>
                <textarea
                  v-model="item.projectFeature"
                  class="input textarea"
                ></textarea>
              </div>
              <div class="column">
                <span class="subtitle">作品</span>
                <div v-if="item.workId" class="word_area flex">
                  <img class="work_cover" :src="item?.workUrl" alt="" />
                  <div class="work_des column">
                    <span class="name">{{ item.workName }}</span>
                    <span class="time">{{
                      $dateTypeFormat("YYYY-mm-dd", new Date(item.updateTime))
                    }}</span>
                  </div>
                  <!-- <img class="delete"  src="@/assets/img/delete_2.png" alt="" /> -->
                </div>
              </div>
            </div>
          </div>
          <!-- 荣誉与认证 -->
          <div v-if="'honorList' == activePDFPage.type" class="column">
            <div class="flex">
              <span class="title">荣誉与认证</span>
              <!-- <div class="checkbox_con flex">
                <input type="checkbox" /><span>在PDF中展示此页</span>
              </div> -->
              <div class="delele_page" @click="deletePage">删除此页</div>
            </div>
            <div class="warmTips">
              <i class="iconfont icon-jinggao"></i
              >&nbsp;&nbsp;每个荣耀只可以绑定一个ppt页面
            </div>
            <div
              class="gray_con"
              v-for="(item, index) in honorList"
              :key="index + 'honorList'"
            >
              <div class="flex">
                <span class="title2">{{ item.name }}</span>
                <div class="checkbox_con flex">
                  <input
                    v-model="item.isShow"
                    @change="changeShow(item)"
                    type="checkbox"
                  /><span>展示</span>
                </div>
              </div>
              <div class="column">
                <span class="subtitle">颁发机构</span>
                <input v-model="item.content" class="input w280" type="text" />
              </div>
              <div class="column">
                <span class="subtitle">颁发日期</span>
                <el-date-picker
                  v-model="item.approveTime"
                  type="date"
                  format="yyyy 年 MM 月 dd 日"
                  :clearable="false"
                >
                </el-date-picker>
              </div>
              <div class="column">
                <span class="subtitle">相关图片</span>
                <div class="img_con">
                  <div
                    class="img_item"
                    v-for="(file, index) in item.fileList"
                    :key="index + 'honorListimg'"
                  >
                    <img :src="file.fileUrl" alt="" />
                    <div class="mask flex">
                      <img
                        @click="toShowImg(file.fileUrl)"
                        src="@/assets/img/look.png"
                        alt=""
                      />
                      <img
                        @click="item.fileList.splice(index, 1)"
                        src="@/assets/img/delete_3.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 团队成员 -->
          <div v-if="'memberList' == activePDFPage.type" class="column">
            <div class="flex">
              <span class="title">团队成员</span>
              <!-- <div class="checkbox_con flex">
                <input type="checkbox" /><span>在PDF中展示此页</span>
              </div> -->
              <div class="delele_page" @click="deletePage">删除此页</div>
            </div>

            <div class="warmTips">
              <i class="iconfont icon-jinggao"></i
              >&nbsp;&nbsp;每个团队成员只可以绑定一个ppt页面
            </div>
            <div
              class="gray_con"
              v-for="(item, index) in memberList"
              :key="index + 'memberList'"
            >
              <div class="editImg" @click="editMemberImg(item)">
                修改头像显示区域
              </div>
              <div class="member_con flex">
                <img class="member_avatar" :src="item.avatar" alt="" />
                <div class="column">
                  <span class="name">{{ item.name }}</span>
                  <span class="position">{{ item.job }}</span>
                </div>
                <div class="checkbox_con flex">
                  <input
                    type="checkbox"
                    v-model="item.isShow"
                    @change="changeShow(item)"
                  /><span>展示</span>
                </div>
              </div>

              <div class="column">
                <span class="subtitle">经历</span>
                <input
                  v-model="item.experience"
                  class="input w280"
                  type="text"
                />
              </div>
              <div class="column">
                <span class="subtitle">项目</span>
                <input
                  v-model="item.projectIntro"
                  class="input w280"
                  type="text"
                />
              </div>
            </div>
          </div>
          <!-- 合作伙伴 -->
          <div v-if="'partnerList' == activePDFPage.type" class="column">
            <div class="flex">
              <span class="title">合作伙伴</span>
              <!-- <div class="checkbox_con flex">
                <input type="checkbox" /><span>在PDF中展示此页</span>
              </div> -->
              <div class="delele_page" @click="deletePage">删除此页</div>
            </div>
            <div class="warmTips">
              <i class="iconfont icon-jinggao"></i
              >&nbsp;&nbsp;每个合作伙伴只可以绑定一个ppt页面
            </div>
            <div
              class="gray_con"
              v-for="(item, index) in userPartnerList"
              :key="index + 'userPartnerList'"
            >
              <div class="flex">
                <span class="title2">合作伙伴</span>
                <div class="checkbox_con flex">
                  <input
                    type="checkbox"
                    v-model="item.isShow"
                    @change="changeShow(item)"
                  /><span>展示</span>
                </div>
              </div>
              <div class="column">
                <span class="subtitle">合作内容</span>
                <input v-model="item.content" class="input w280" type="text" />
              </div>
              <div class="column">
                <span class="subtitle">合作时间</span>
                <el-date-picker
                  v-model="item.approveTime"
                  type="date"
                  format="yyyy 年 MM 月 dd 日"
                  :clearable="false"
                >
                </el-date-picker>
              </div>
              <div class="column">
                <span class="subtitle">相关图片</span>
                <div class="img_con">
                  <div
                    class="img_item"
                    v-for="(file, index) in item.fileList"
                    :key="index + 'userPartnerListtimg'"
                  >
                    <img :src="file.fileUrl" alt="" />
                    <div class="mask flex">
                      <img
                        @click="toShowImg(file.fileUrl)"
                        src="@/assets/img/look.png"
                        alt=""
                      />
                      <img
                        @click="item.fileList.splice(index, 1)"
                        src="@/assets/img/delete_3.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 联系方式页 -->
          <div v-if="'contact' == activePDFPage.type" class="column">
            <div class="title contact-title">
              <span>联系方式</span>
              <div class="flex">
                <el-link
                  type="primary"
                  :underline="false"
                  @click="
                    () => {
                      showAddContact = true;
                    }
                  "
                  >选择联系人</el-link
                >&nbsp;

                <div
                  class="delele_page"
                  @click="deletePage"
                  v-if="activePDFPage.canCopy"
                >
                  删除此页
                </div>
              </div>
            </div>

            <div
              class="contact-item"
              v-for="(item, index) in pdfPage[activeBoardIndex].multipleData"
              :key="index"
            >
              <div class="column">
                <span class="subtitle">联系人姓名</span>
                <input type="text" class="input" v-model="item.name" />
              </div>
              <div class="column">
                <span class="subtitle">手机号</span>
                <input type="text" class="input" v-model="item.tel" />
              </div>
              <div class="column">
                <span class="subtitle">微信</span>
                <input type="text" class="input" v-model="item.wx" />
              </div>
            </div>
            <div class="column">
              <span class="subtitle">微信二维码</span>
              <div class="code_con flex" @click="seletctImg('wxUrl')">
                <img
                  class="code"
                  v-if="userInfo.loginUser.wxUrl"
                  :src="userInfo.loginUser.wxUrl"
                  alt=""
                />
              </div>
            </div>
            <div class="column">
              <span class="subtitle">公司地址</span>
              <textarea
                class="input textarea2"
                v-model="userInfo.loginUser.city"
              ></textarea>
            </div>

            <div class="column">
              <span class="subtitle">邮箱</span>
              <input
                type="text"
                class="input"
                v-model="userInfo.loginUser.email"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <qrCode
      :qr-value="h5Url"
      :width="100"
      foreground="#07C160"
      ref="qrcode"
      v-model="qrCodeVisible"
      :temp-index="+activeTemplate"
    />
    <imgCropper
      v-model="showEditImg"
      :current-member="currentMember"
      :is-circle="true"
      aspectRatio="1:1"
      title="编辑头像"
    ></imgCropper>

    <addContactDia
      v-model="showAddContact"
      @addContact="addContact"
    ></addContactDia>
  </div>
</template>
<script>
import {
  userProjectList,
  userApproveList,
  companyMemberList,
  saveQrCode,
  getXcxQrCode,
  updateAppInfo,
} from "@/assets/js/request";
import PDFTemlateList from "@/assets/js/PDFTemlateList";
import Template_1 from "@/components/PDFTemplate/Template_1.vue";
import Template_13 from "@/components/PDFTemplate/Template_13.vue";
import PDFList from "@/components/CenterTools/PDFList.vue";
import imgCropper from "./imgCropper.vue";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { mapState, mapMutations } from "vuex";
import qrCode from "./qrCode.vue";
import { testVideo, SimplifiedSceneCompressor } from "../assets/js/common.js";
import addContactDia from "@/components/addContactDia.vue";
import NewUserGuide from "@/components/NewUserGuide.vue";
export default {
  components: {
    PDFList,
    Template_1,
    Template_13,
    qrCode,
    imgCropper,
    addContactDia,
    NewUserGuide,
  },
  props: {
    activeTemplate: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      activeBoardIndex: 0, //左侧选中的当前页数
      productList: [], //服务与产品列表
      projectList: [], //项目与案例列表
      honorList: [], //荣誉与认证
      userPartnerList: [], //合作伙伴
      memberList: [], //团队成员
      pdfPage: [], //总共的pdf页
      activePDFType: "", //右侧展示数据类型
      accept: ".png,.jpg,.jpeg,.bmp,.PNG,.JPG,.JPEG,.BMP",
      scaleRadio: 100,
      downloading: false,
      showPDFList: false, //展示pdf模板页
      h5Url: "",
      qrCodeVisible: false,
      showEditImg: false,
      currentMember: {},
      showAddContact: false,

      showGuide: false,
      popupCotent: "", //弹窗文本内容
      guideIndex: 1,
      lastIndex: 1,
      guideContent: "右侧默认数据是从个人资料中编辑而来，可以进行修改",
      top: 150,
      left: -150,
      arrowPosition: "right",
    };
  },
  computed: {
    ...mapState([
      "userInfo",
      "paramsId",
      "activeCompanyInfo",
      "usedAppId",
      "historyList",
    ]),
    scale() {
      return { transform: scale(this.scaleRadio / 100) };
    },
    activePDFPage() {
      return this.pdfPage[this.activeBoardIndex];
    },
    //当前渲染模板名
    currentComponent() {
      return `Template_${this.activeTemplate}`;
    },
  },
  watch: {
    activeBoardIndex: {
      handler: function (newVal, oldVal) {
        if (oldVal === 0)
          this.this.$nextTick(() => {
            this.getActiveShow(newVal);
          });
      },
      immediate: true,
    },
    activePDFPage: {
      handler: function (newVal) {
        this.$nextTick(() => {
          console.log("数据改变，重新获取视图");
          this.refreshThumbnails(this.activeBoardIndex);
          this.getActiveShow(this.activeBoardIndex);
          console.log(this.pdfPage, "pdfPage");
        });
      },
      deep: true,
    },
    activeTemplate(value) {
      this.productList.forEach((item) => {
        item.belong = null;
      });
      this.projectList.forEach((item) => {
        item.belong = null;
      });
      this.honorList.forEach((item) => {
        item.belong = null;
      });
      this.userPartnerList.forEach((item) => {
        item.belong = null;
      });
      this.memberList.forEach((item) => {
        item.belong = null;
      });
    },
  },
  methods: {
    toInit() {
      this.$set(this.activeCompanyInfo, "brand", "星光传媒");
      this.pdfPage = [];
      let pdfTemplate = {};
      //确定模板页
      for (let i = 0; i < PDFTemlateList.length; i++) {
        if (PDFTemlateList[i].id == this.activeTemplate) {
          pdfTemplate = PDFTemlateList[i];
        }
      }
      let typeList = pdfTemplate.typeList;
      for (const key in typeList) {
        console.log("key", key);
        for (let i = 0; i < typeList[key].length; i++) {
          let item = {
            thumbnail: "",
            type: key,
            typeIndex: i,
            data: {},
            isCover: typeList[key][i].isCover ? true : false,
          };
          const uniquePart = Math.random().toString(36).slice(2, 11);
          item.id = `item-${Date.now()}-${uniquePart}-${key}`;
          if (key != "mainInfo" && key != "contact" && !item.isCover) {
            item.canCopy = true;
            if (typeList[key][i].type == "multiple") {
              item.multipleData = [];
              item.maxLength = typeList[key][i].maxLength;
              item.qrdata = typeList[key][i].qrData;
            } else {
              item.qrdata = typeList[key][i].qrData;
            }
          }
          if (key == "contact") {
            item.data = this.userInfo.loginUser;
            item.multipleData = [];
            item.canCopy = typeList[key][i].canAdd;
            item.maxLength = typeList[key][i].maxLength;
          }
          this.pdfPage.push(item);
          if (key == "mainInfo") {
            item.data = this.activeCompanyInfo;
            item.data.history = this.$store.state.historyList;
            item.canCopy = typeList[key][i].canAdd;
          }
        }
      }
      this.$nextTick(() => {
        this.createThumbnails();
      });
      console.log(this.pdfPage, "this.pdfPage");
    },
    listen(e) {
      const sortPanel = document.getElementById("sortPanel");
      const sortType = document.getElementById("sortType");
      console.log(e.target);
      // 如果点击的区域不在弹框内部;
      if (!sortPanel.contains(e.target) && e.target !== sortType) {
        // 隐藏弹框
        this.showPDFList = false;
        this.syncEventListeners();
      }
    },
    syncEventListeners() {
      // 根据弹窗状态添加/移除事件监听
      if (this.showPDFList) {
        document.addEventListener("click", this.listen);
      } else {
        document.removeEventListener("click", this.listen);
      }
    },
    checkShowPDFList() {
      this.showPDFList = !this.showPDFList;
      this.syncEventListeners();
    },
    checkTemplate(e) {
      this.activeTemplate = e;
      this.toInit();
    },
    copyPage(item, index) {
      //重置一些数据
      if (item.type !== "mainInfo" && item.type !== "contact") {
        item = JSON.parse(JSON.stringify(item));
        const uniquePart = Math.random().toString(36).slice(2, 11);
        item.id = `item-${Date.now()}-${uniquePart}-${item.type}`;
        item.data = {};
        item.thumbnail = "";
        if (item.multipleData) {
          item.multipleData = [];
        }
      } else if (item.type === "contact") {
        item = JSON.parse(JSON.stringify(item));
        item.multipleData = [];
      }

      this.pdfPage.splice(index + 1, 0, item);
      this.refreshThumbnails(index + 1);
      console.log(this.pdfPage, "copyPage  ");
    },
    deletePage() {
      this.pdfPage.splice(this.activeBoardIndex, 1);
      this.activeBoardIndex -= 1;
    },
    async getActiveShow(activeIndex) {
      await this.$nextTick();
      let sourceParent = document.getElementById("allShow");
      let targetParent = document.getElementById("activeShow");
      let clonedChild =
        sourceParent?.children[activeIndex]?.children[0]?.cloneNode(true);

      clonedChild?.classList.remove("template_con");
      clonedChild?.classList.add("template_con2");
      // 添加到目标父元素
      targetParent.innerHTML = "";
      targetParent.appendChild(clonedChild);
    },
    async createThumbnails() {
      const blocks = document.querySelectorAll(".template_con");
      console.log(blocks, "blocks");
      for (let i = 0; i < blocks.length; i++) {
        // 使用 html2canvas 生成缩略图
        const canvas = await html2canvas(blocks[i], {
          scale: 0.2, // 缩放比例
          useCORS: true,
        });
        this.pdfPage[i].thumbnail = canvas.toDataURL();
      }
    },
    async refreshThumbnails(index) {
      this.inlineCriticalCSS();
      const blocks = document.querySelectorAll(".template_con");
      const canvas = await html2canvas(blocks[index], {
        scale: 0.2, // 缩放比例
        useCORS: true,
      });
      this.pdfPage[index].thumbnail = canvas.toDataURL();
    },

    async changeShow(item, type) {
      if (item.isShow) {
        if (this.pdfPage[this.activeBoardIndex].isCover) {
          this.$message.warning("当前pdf页面无法填充内容！");
          await this.$nextTick();
          item.isShow = false;
          return;
        }
        if (
          !item.xcxQrCode &&
          this.$store.state.usedAppId &&
          type === "projectList"
        ) {
          if (item.workUrl) {
            this.getXcxQrCode(item);
          } else {
            this.$message.warning("该项目未绑定作品，无法生成小程序码");
          }
        }
        if (this.activePDFPage.multipleData) {
          if (
            this.activePDFPage.multipleData.length ==
            this.activePDFPage.maxLength
          ) {
            this.$nextTick(() => {
              item.isShow = false;
            });
            this.$message({
              message: `已超过当前页面最大数据`,
              type: "warning",
            });
            return;
          }
          this.$set(item, "belong", this.activePDFPage.id);
          this.pdfPage[this.activeBoardIndex].multipleData.push(item);
        } else {
          if (this.activePDFPage.data.id) {
            this.$nextTick(() => {
              item.isShow = false;
            });
            this.$message({
              message: `当前页面只允许选择一项数据，要切换数据请先取消展示当前已选择数据`,
              type: "warning",
            });
            return;
          }
          this.$set(item, "belong", this.activePDFPage.id);
          this.pdfPage[this.activeBoardIndex].data = item;
        }
      } else {
        if (this.activePDFPage.multipleData) {
          for (let i = 0; i < this.activePDFPage.multipleData.length; i++) {
            if (this.activePDFPage.multipleData[i].id == item.id) {
              this.$set(item, "belong", null);
              this.activePDFPage.multipleData.splice(i, 1);
              break;
            }
          }
        } else {
          this.$set(item, "belong", null);
          this.pdfPage[this.activeBoardIndex].data = {};
        }
      }
      console.log(this.activePDFPage, "activePDFPage");
      this.$nextTick(() => {
        this.refreshThumbnails(this.activeBoardIndex);
        this.getActiveShow(this.activeBoardIndex);
      });
    },
    getProjectList() {
      userProjectList(this.paramsId).then((res) => {
        this.productList = res.data.userProductList;
        this.projectList = res.data.userProjectList;
        this.projectList.forEach((item, index) => {
          const videoItem = item.fileList
            ? item.fileList.find((file) => testVideo(file.fileUrl))
            : null;
          if (videoItem) {
            this.$set(item, "videoSrc", videoItem.fileUrl);
            this.$set(item, "qrName", `qrCode${index}`);
          }
        });
        console.log(this.projectList, "projectList");
        for (let i = 0; i < this.productList.length; i++) {
          this.$set(this.productList[i], "isShow", false);
          this.$set(this.productList[i], "belong", null);
        }
        for (let i = 0; i < this.projectList.length; i++) {
          this.$set(this.projectList[i], "isShow", false);
          this.$set(this.projectList[i], "belong", null);
        }
      });
    },
    getApproveList() {
      userApproveList(this.paramsId).then((res) => {
        this.honorList = res.data.userApproveList;
        this.userPartnerList = res.data.userPartnerList;
        for (let i = 0; i < this.honorList.length; i++) {
          this.$set(this.honorList[i], "isShow", false);
          this.$set(this.honorList[i], "belong", null);
        }
        for (let i = 0; i < this.userPartnerList.length; i++) {
          this.$set(this.userPartnerList[i], "isShow", false);
          this.$set(this.userPartnerList[i], "belong", null);
        }
      });
    },
    getCompanyMemberList() {
      companyMemberList({
        companyId: this.paramsId.companyId,
        pageNum: 1,
        pageSize: 10,
      }).then((res) => {
        this.memberList =
          res.data.rows || [];
        for (let i = 0; i < this.memberList.length; i++) {
          this.$set(this.memberList[i], "isShow", false);
          this.$set(this.memberList[i], "belong", null);
        }
      });
    },
    // 在生成PDF前执行样式内联
    inlineCriticalCSS() {
      document.querySelectorAll(".template_con").forEach((element) => {
        const styles = window.getComputedStyle(element);
        // 内联关键样式（示例）
        element.style.cssText += `
      box-shadow: ${styles.boxShadow};
      border-radius: ${styles.borderRadius};
      font-family: ${styles.fontFamily};
    `;
      });
    },
    // 异步生成PDF
    async generatePDF() {
      if (this.downloading) return;
      this.downloading = true;

      this.inlineCriticalCSS();
      // 获取需要分页的DOM元素
      let pageElements = document.querySelectorAll(".template_con");

      // 固定宽高设置（800x450）
      const fixedWidth = 800;
      const fixedHeight = 450;

      // 创建PDF对象（使用固定尺寸）
      const doc = new jsPDF({
        orientation: fixedWidth > fixedHeight ? "landscape" : "portrait",
        unit: "px", // 使用像素单位，与固定尺寸保持一致
        format: [fixedWidth, fixedHeight], // 直接设置PDF页面尺寸为800x450
      });

      // 设置PDF生成参数
      const pdfOptions = {
        scale: 2, // 提高生成质量
        dpi: 300,
        background: "#fff",
      };

      try {
        // 保存编辑的pdf数据到默认app模板
        if (this.usedAppId) {
          const appData = [
            {
              title: "封面",
              canDelete: false,
              canAdd: false,
              type: "mainInfo",
              showCheck: false,
              arr: [],
            },
            {
              title: "产品与服务",
              canDelete: true,
              canAdd: false,
              type: "productList",
              showCheck: true,
              arr: [],
            },
            {
              title: "项目和案例",
              canDelete: true,
              canAdd: true,
              type: "projectList",
              showCheck: true,
              arr: [],
            },
            {
              title: "荣誉与认证",
              canDelete: true,
              type: "honorList",
              canAdd: true,
              showCheck: true,
              arr: [],
            },
            {
              title: "团队成员",
              canDelete: true,
              type: "memberList",
              canAdd: true,
              showCheck: true,
              arr: [],
            },
            {
              title: "合作伙伴",
              canDelete: true,
              type: "partnerList",
              canAdd: true,
              showCheck: true,
              arr: [],
            },
            {
              title: "联系方式",
              canDelete: false,
              type: "contact",
              canAdd: false,
              arr: [],
            },
          ];
          this.pdfPage.forEach((item) => {
            if (item.type == "mainInfo" && !item.isCover) {
              appData[0].arr[0] = item.data;
            } else if (item.type == "productList" && !item.isCover) {
              if (item.hasOwnProperty("multipleData")) {
                item.multipleData.forEach((item2) => {
                  appData[1].arr.push({
                    ...item2,
                    isShow: true,
                  });
                });
              } else {
                appData[1].arr.push(item.data);
              }
            } else if (item.type == "projectList" && !item.isCover) {
              if (item.hasOwnProperty("multipleData")) {
                item.multipleData.forEach((item2) => {
                  appData[2].arr.push({
                    ...item2,
                    isShow: true,
                  });
                });
              } else {
                appData[2].arr.push({
                  ...item.data,
                  isShow: true,
                });
              }
            } else if (item.type == "honorList" && !item.isCover) {
              if (item.hasOwnProperty("multipleData")) {
                item.multipleData.forEach((item2) => {
                  appData[3].arr.push({
                    ...item2,
                    isShow: true,
                  });
                });
              } else {
                appData[3].arr.push({
                  ...item.data,
                  isShow: true,
                });
              }
            } else if (item.type == "memberList" && !item.isCover) {
              if (item.hasOwnProperty("multipleData")) {
                item.multipleData.forEach((item2) => {
                  appData[4].arr.push({
                    ...item2,
                    isShow: true,
                  });
                });
              } else {
                appData[4].arr.push({
                  ...item.data,
                  isShow: true,
                });
              }
            } else if (item.type == "partnerList" && !item.isCover) {
              if (item.hasOwnProperty("multipleData")) {
                item.multipleData.forEach((item2) => {
                  appData[5].arr.push({
                    ...item2,
                    isShow: true,
                  });
                });
              } else {
                appData[5].arr.push({
                  ...item.data,
                  isShow: true,
                });
              }
            } else if (item.type == "contact" && !item.isCover) {
              appData[6].arr = appData[6].arr.concat(
                item.multipleData.slice(0, item.maxLength)
              );
              appData[6].companyContact = item.data;
            }
          });
          this.handleSaveApp(JSON.stringify(appData));
        }

        const watermarks = [];
        // 遍历所有分页元素
        for (let i = 0; i < pageElements.length; i++) {
          const element = pageElements[i];

          // 强制设置元素尺寸为800x450，确保内容填充
          element.style.width = `${fixedWidth}px`;
          element.style.height = `${fixedHeight}px`;
          element.style.margin = "0";
          element.style.padding = "0";
          element.style.overflow = "hidden"; // 防止内容溢出产生滚动条

          // 动态创建水印元素
          const watermark = document.createElement("div");
          // 水印样式：右下角、半透明、旋转角度（可自定义）
          watermark.style.cssText = `
            position: absolute !important;
            right: 20px !important; /* 右间距 */
            bottom: 80px !important; /* 下间距 */
            color: rgba(255, 255, 255, 0.1) !important; /* 半透明灰色 */
            font-size: 24px; /* 水印大小 */
            font-weight: bold;
            transform: rotate(30deg); /* 旋转角度 */
            pointer-events: none; /* 不影响交互 */
            z-index: 99999; /* 确保在内容上方 */
          `;
          watermark.textContent =
            this.pdfPage[this.activeBoardIndex].data.companyName; // 水印文字（可替换为图片）
          watermarks.push(watermark); // 记录水印元素

          // 将水印添加到当前分页元素中（需确保元素是relative定位，否则水印可能偏移）
          element.style.position = "relative"; // 确保水印相对于该元素定位
          element.appendChild(watermark);
          await new Promise((resolve) => setTimeout(resolve, 100));
          // 用html2canvas将DOM元素转换为canvas（尺寸与PDF一致）
          const canvas = await html2canvas(element, {
            logging: false,
            useCORS: true,
            scale: pdfOptions.scale,
            width: fixedWidth,
            height: fixedHeight,
            windowWidth: fixedWidth,
            windowHeight: fixedHeight,
            // 裁剪到精确尺寸，确保无多余内容
            x: 0,
            y: 0,
            scrollX: 0,
            scrollY: 0,
          });

          // 移除水印
          element.removeChild(watermark);

          // 将canvas转换为图片数据
          const imgData = canvas.toDataURL("image/png", 1.0);

          // 如果不是第一页，添加新页面（保持相同尺寸）
          if (i > 0) {
            doc.addPage(
              [fixedWidth, fixedHeight],
              fixedWidth > fixedHeight ? "landscape" : "portrait"
            );
          }

          // 直接填充整个页面，无偏移无留白
          doc.addImage({
            imageData: imgData,
            x: 0, // 左上角x坐标
            y: 0, // 左上角y坐标
            width: fixedWidth, // 与PDF宽度一致
            height: fixedHeight, // 与PDF高度一致
            format: "PNG",
          });
        }
        watermarks.forEach((watermark) => {
          if (watermark.parentNode) {
            watermark.parentNode.removeChild(watermark);
          }
        });
        // 保存PDF文件
        doc.save(`导出文件-${new Date().getTime()}.pdf`);
        this.downloading = false;
      } catch (error) {
        console.error("生成PDF失败:", error);
        this.downloading = false;
      }
    },
    reduce() {
      if (this.scaleRadio == 25) {
        this.$message({
          message: `已是最小视图`,
          type: "warning",
        });
        return;
      }
      this.scaleRadio -= 25;
    },
    plus() {
      if (this.scaleRadio == 200) {
        this.$message({
          message: `已是最大视图`,
          type: "warning",
        });
        return;
      }
      this.scaleRadio += 25;
    },
    toShowImg(url) {
      window.open(url, "_blank");
    },
    seletctImg(fileList) {
      if (document.getElementById("fileInput")) {
        document.body.removeChild(document.getElementById("fileInput"));
      }
      let input = document.createElement("input");
      input.id = "fileInput";
      input.type = "file";
      input.style.display = "none";
      input.accept = this.accept;

      document.body.appendChild(input);
      input.addEventListener("change", (e) => {
        this.checkFile(input.files[0], fileList);
      });
      input.click();
    },
    checkFile(file, fileList) {
      let exts = file.name.split(".").pop().toLowerCase();
      if (!this.accept.toLowerCase().includes(exts)) {
        this.$message({
          message: `不支持当前图片格式，请添加${this.accept}格式的图片`,
          type: "error",
        });
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message({
          message: `图片超过大小，请添加10M以下的图片`,
          type: "error",
        });
        return;
      }
      this.dealFile(file, fileList);
    },
    dealFile(file, fileList) {
      const reader = new FileReader();
      reader.onload = (e) => {
        let item = {};
        item.fileUrl = e.target.result;
        if (Array.isArray(fileList)) {
          fileList.push(item);
        } else if ("wxUrl" == fileList) {
          this.userInfo.loginUser.wxUrl = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    },
    async createQrcode() {
      try {
        const params = {
          userId: this.userInfo.loginUser.id,
          pdfId: this.activeTemplate,
          pdfData: JSON.stringify(this.pdfPage),
        };
        await saveQrCode(params);
        this.qrCodeVisible = true;
      } catch (error) {}
    },

    async getXcxQrCode(item) {
      try {
        const temp = {
          STUDIO: "1",
          COMPANY: "2",
          USER: "0",
        };
        const compressed = SimplifiedSceneCompressor.compress(
          `${this.userInfo.loginUser.id}/${this.$store.state.usedAppId}/${
            temp[this.userInfo.loginUser.permission]
          }/${item.workId}`
        );
        const params = {
          // scene: `a=${compressed}`,
          scene: compressed,
          page: "pages/works/workdetail",
          version: "release",
        };
        const res = await getXcxQrCode(params);
        const url = this.convertQrcodeToUrl(res);
        this.$set(item, "xcxQrCode", url);
      } catch (e) {}
    },
    convertQrcodeToUrl(qrcodeData) {
      // 如果是Blob对象，使用createObjectURL创建临时URL
      if (qrcodeData instanceof Blob) {
        return URL.createObjectURL(qrcodeData);
      }

      // 如果是Base64字符串，拼接成完整的DataURL
      if (typeof qrcodeData === "string") {
        // 检查是否已经包含data:前缀
        if (!qrcodeData.startsWith("data:")) {
          // 默认为PNG格式，实际应根据接口返回的格式调整
          return `data:image/png;base64,${qrcodeData}`;
        }
        return qrcodeData;
      }

      throw new Error("不支持的二维码数据类型");
    },

    async handleSaveApp(appData) {
      try {
        const params = {
          appId: this.usedAppId,
          appData,
          companyId:
            this.$store.state.userInfo.companyInfo.type === "0"
              ? "0"
              : this.$store.state.paramsId.companyId,
        };
        const res = await updateAppInfo(params);
        if (res.code !== 200) {
          this.$message.error(res.msg);
          throw new Error(res.msg);
        }
      } catch (error) {
        this.$message.error(error);
      }
      this.saveLoading = false;
    },

    editMemberImg(item) {
      this.showEditImg = true;
      this.currentMember = item;
    },

    addContact(arr) {
      this.activePDFPage.multipleData =
        this.activePDFPage.multipleData.concat(arr);
    },

    onNext() {
      if (this.guideIndex === this.lastIndex) {
        this.guideIndex = 1;
        this.showGuide = false;
        const guideInfo = localStorage.getItem(
          this.userInfo.loginUser.id + "mphzGuideInfo"
        );
        if (!guideInfo) {
          localStorage.setItem(
            this.userInfo.loginUser.id + "mphzGuideInfo",
            JSON.stringify({ pdf: true })
          );
        } else {
          localStorage.setItem(
            this.userInfo.loginUser.id + "mphzGuideInfo",
            JSON.stringify({ ...JSON.parse(guideInfo), pdf: true })
          );
        }
      } else {
        this.guideIndex++;
      }
    },
  },
  async created() {
    this.toInit();
    this.getProjectList();
    this.getApproveList();
    this.getCompanyMemberList();

    const guideInfo = localStorage.getItem(
      this.userInfo.loginUser.id + "mphzGuideInfo"
    );
    if (!guideInfo || !JSON.parse(guideInfo).pdf) {
      await this.$nextTick();
      const parentEle = this.$refs.main_content;
      const parentWidth = window.getComputedStyle(parentEle).width;
      this.left = parentWidth.split("px")[0] - 660;
      this.showGuide = true;
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  // width: 280px;
  height: 40px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #242424;
  padding: 0 32px;
}

.editImg {
  color: #9bdb4a;
  cursor: pointer;
  font-size: 14px;
}
::v-deep .el-input__icon {
  line-height: 40px;
}

.WorkDetail {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 20;
  .close {
    width: 24px;
    height: 24px;
    margin: 12px 24px 12px auto;
    cursor: pointer;
  }

  .main {
    height: 100%;
    background: #ffffff;
    border-radius: 24px 24px 0px 0px;

    .head {
      height: 80px;
      border-bottom: 1px solid #eeeeee;
      padding: 0 32px;

      .head_title {
        font-weight: 600;
        font-size: 24px;
        color: #242424;
        margin-right: 20px;
      }

      .change_btn {
        width: 102px;
        height: 28px;
        border-radius: 100px;
        font-size: 12px;
        color: #242424;
        border: 1px solid #242424;
        justify-content: center;
        position: relative;
        cursor: pointer;

        > img {
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }
      }

      .download_btn {
        width: 92px;
        height: 32px;
        background: #242424;
        border-radius: 100px;
        text-align: center;
        line-height: 32px;
        font-size: 12px;
        color: #f3f3f3;
        margin-left: auto;
        cursor: pointer;
      }
    }

    .main_content {
      height: 100%;
      align-items: flex-start;
      position: relative;
      .content_left {
        width: 208px;
        height: calc(100% - 126px);
        background: #ffffff;
        border-right: 1px solid #eeeeee;
        padding: 0 24px;
        overflow-y: auto;
        overflow-x: hidden;

        .content_left_title {
          height: 24px;
          font-weight: 500;
          font-size: 16px;
          color: #242424;
          line-height: 24px;
          margin: 24px 0;
        }

        .board_item {
          position: relative;
          width: 160px;
          height: 90px;
          background: #ffffff;
          box-shadow: 0px 3px 24px 0px rgba(151, 151, 151, 0.08);
          border-radius: 4px;
          border: 1px solid #e0e0e0;
          margin-bottom: 20px;
          flex-shrink: 0;
          cursor: pointer;

          .thumbnail_item {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .num {
            position: absolute;
            top: 9px;
            right: 9px;
            width: 20px;
            height: 20px;
            background: rgba(36, 36, 36, 0.3);
            border-radius: 4px;
            text-align: center;
            line-height: 20px;
            font-weight: 600;
            font-size: 14px;
            color: #ffffff;
          }

          .copy {
            display: none;
            position: absolute;
            left: 50%;
            bottom: -14px;
            transform: translateX(-50%);
            width: 28px;
            height: 28px;
            background: #9ce14a;
            border-radius: 50%;
            justify-content: center;
            cursor: pointer;

            > img {
              width: 16px;
              height: 16px;
            }
          }

          &:hover {
            border: 2px solid #9bdb4a;

            .copy {
              display: flex;
            }
          }
        }

        .active_board_item {
          border: 2px solid #9bdb4a;

          .num {
            background: #9ce14a;
            color: #242424;
          }
        }
      }

      .content_middle {
        height: calc(100% - 130px);
        flex-grow: 1;
        background: #f9f9f9;
        padding: 20px;
        justify-content: center;
        position: relative;
        overflow-x: auto;
        overflow-y: hidden;

        .scale_panel {
          position: absolute;
          right: 36px;
          bottom: 28px;
          height: 28px;
          background: #ffffff;
          padding: 0 8px;
          font-size: 12px;
          color: #242424;

          > img {
            width: 16px;
            height: 16px;
            margin-right: 8px;
            cursor: pointer;
          }
        }
      }

      .content_right {
        width: 360px !important;
        min-width: 360px !important;
        height: 100%;
        background: #ffffff;
        border-left: 1px solid #eeeeee;
        padding: 24px;
        height: calc(100% - 126px);
        overflow-y: auto;
        overflow-x: hidden;
        .warmTips {
          color: red;
          margin-top: 10px;
          font-size: 14px;
        }
        .title {
          height: 24px;
          font-weight: 500;
          font-size: 16px;
          color: #242424;
          line-height: 24px;
        }

        .delele_page {
          margin-left: auto;
          padding: 0 14px;
          border: 1px solid #ff4d4f;
          border-radius: 10px;
          height: 24px;
          font-size: 14px;
          color: #ff4d4f;
          line-height: 24px;
          cursor: pointer;
        }

        .title2 {
          height: 22px;
          font-weight: 500;
          font-size: 14px;
          color: #242424;
          line-height: 22px;
        }

        .subtitle {
          height: 22px;
          font-size: 14px;
          color: #8b8b8b;
          line-height: 22px;
          margin-top: 20px;
          margin-bottom: 4px;
        }

        .checkbox_con {
          margin-left: auto;
          z-index: 1;
          > span {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
            margin-left: 2px;
          }
        }

        .input {
          width: 100%;
          height: 40px;
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #cccccc;
          padding: 0 12px;
          font-size: 14px;
          color: #191919;

          ::placeholder {
            color: #999999;
          }

          &:focus {
            background: #fafafa;
          }
        }

        .w280 {
          width: 280px;
        }

        .textarea {
          width: 280px;
          height: 84px;
          border: 1px solid #666666;
          padding: 9px 12px;

          &:focus {
            background: #ffffff;
          }
        }

        .textarea2 {
          width: 312px;
          height: 84px;
          border: 1px solid #cccccc;
          padding: 9px 12px;
        }

        .gray_con {
          width: 312px;
          padding: 16px;
          background: #fafafa;
          border-radius: 8px;
          margin-top: 20px;
          position: relative;

          .mask {
            position: absolute;
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0.8);
            bottom: 0;
            left: 0;
            z-index: 2;
          }

          .img_con {
            display: flex;
            flex-wrap: wrap;

            .upload_area {
              width: 88px;
              height: 88px;
              background: #fafafa;
              border-radius: 2px;
              border: 1px dashed #d9d9d9;
              align-items: center;
              justify-content: center;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.45);
              margin: 0 8px 8px 0;
              flex-shrink: 0;
              cursor: pointer;

              img {
                width: 14px;
                height: 14px;
                margin-bottom: 8px;
              }

              &:hover {
                border: 1px dashed #666666;
                color: #242424;
              }
            }

            .img_item {
              width: 88px;
              height: 88px;
              border-radius: 2px;
              border: 1px solid #d9d9d9;
              padding: 9px;
              margin: 0 8px 8px 0;
              position: relative;

              &:hover {
                .mask {
                  display: flex;
                }
              }

              .mask {
                display: none;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.45);
                justify-content: center;

                > img {
                  width: 14px;
                  height: 14px;
                  margin: 0 4px;
                  cursor: pointer;
                }
              }

              &:nth-of-type(3n) {
                margin-right: 0px;
              }

              img {
                width: 70px;
                height: 70px;
              }
            }
          }

          .word_area {
            width: 280px;

            .work_cover {
              width: 83px;
              height: 62px;
              border-radius: 3px;
              margin-right: 12px;
            }

            .work_des {
              .name {
                height: 26px;
                font-weight: 600;
                font-size: 18px;
                color: #242424;
                line-height: 26px;
              }

              .time {
                height: 22px;
                font-size: 14px;
                color: #242424;
                line-height: 22px;
              }
            }

            .delete {
              width: 20px;
              height: 20px;
              margin-left: auto;
              cursor: pointer;
            }
          }

          .member_con {
            .member_avatar {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-right: 12px;
            }

            .name {
              height: 22px;
              font-weight: 500;
              font-size: 14px;
              color: #242424;
              line-height: 22px;
            }

            .position {
              height: 22px;
              font-size: 14px;
              color: #242424;
              line-height: 22px;
            }
          }
        }

        .code_con {
          width: 136px;
          height: 136px;
          border-radius: 4px;
          border: 1px solid #e0e0e0;
          padding: 8px;
          justify-content: center;

          .code {
            width: 120px;
            height: 120px;
            border-radius: 2px;
          }
        }
        .qrcode-con {
          margin: 20px auto;
          width: 100px;
        }
      }
    }
  }
  .historyInput {
    width: 100%;
  }
  .contact-title {
    display: flex;
    justify-content: space-between;
  }
  .contact-item {
    padding: 0 9px 9px;
    margin-bottom: 11px;
    background: #fafafa;
    border-radius: 4px;
  }
}
</style>
